import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useRef, useState } from "react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Bar,
  ComposedChart,
  Line,
  Cell,
} from "recharts";
import GrossRevenueIcon from "../../../../../../images/common/activity-blue.svg";
import {
  AcitivityGraphToolTip,
  FilterTimePeriod,
  RespresentativeBox,
  SensexBox,
} from "./DashboardMain.styles";
import { observer } from "mobx-react";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Loader,
  SingleSelect,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import {  DashboardService } from "../../../shared/services";
import {
  ActivityGraphDataModel,
  ActivityGraphWidgetDataModel,
} from "../../../shared/models";
import { AccountSettingsStore } from "../../../shared/store";
// import { Dropdown } from 'react-bootstrap';
//import TickIcon from '@assets/images/common/tick-royal-blue.svg';

type IProps = {
  dashboardStore: DashboardStore;
  location: Location;
  merchantAccountId: string;
};

type IHighLightedBar = {
  index: number;
  isCurrentPeriod: boolean;
  isPriorPeriod: boolean;
  isProjected: boolean;
};
const ActivityGraphWidget: FC<IProps> = ({
  dashboardStore,
  location,
  merchantAccountId,
}) => {
  const [showLoader, setLoader] = useState(false);
  const [isRequestInProgress, setRequestStatus] = useState(false);
  const [type, setType] = useState("GrossRevenue");
  const [filter, setFilterType] = useState("MTD");
  const filterOptions = [
    "1W",
    "4W",
    "1Q",
    "1Y",
    "TODAY",
    "WTD",
    "MTD",
    "QTD",
    "YTD",
    "All",
  ];
  const [openPriorPeriod, setPriorPeriodOpen] = useState(false);
  const [priorPeriodValue, setPeriorPeriod] = useState("");
  const ref = useRef<HTMLDivElement>(null);
  const [activeBar, setActiveBar] = useState<IHighLightedBar | null>(null);
  function isTestMode() {
    return (
      new URLSearchParams(location.search).get("testMode")?.toLowerCase() ===
      "true"
    );
  }

  function handleMouseEnter(
    index: number,
    isCurrentPeriod: boolean,
    isPriorPeriod: boolean,
    isProjectedPeriod: boolean
  ) {
    setActiveBar({
      index: index,
      isCurrentPeriod: isCurrentPeriod,
      isPriorPeriod: isPriorPeriod,
      isProjected: isProjectedPeriod,
    } as IHighLightedBar);
  }

  const handleMouseLeave = () => {
    setActiveBar(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setTimeout(() => {
          togglePriorPeriod();
        });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    loadData();
  }, [type, filter, isTestMode(), priorPeriodValue, merchantAccountId]);

  function togglePriorPeriod() {
    setPriorPeriodOpen(!openPriorPeriod);
  }

  function loadData() {
    //if (!merchantAccountId) return;
    setRequestStatus(true);
    DashboardService.getActivityGraphData(
      AuthService.authData.accountId,
      merchantAccountId,
      type,
      filter,
      "2024-04-04T09:46:58.202Z",
      "2024-06-04T09:46:58.202Z",
      isTestMode(),
      priorPeriodValue
    ).subscribe({
      next: (response) => {
        setLoader(false);
        setRequestStatus(false);
        if (response.result.type != type) {
          setType(response.result.type);
        }

        if (response.result.filter != filter) {
          setFilterType(response.result.filter);
          openPriorPeriod && togglePriorPeriod();
        }
        const mappedData = ActivityGraphWidgetDataModel.deserializeAPIModel(
          response.result
        );
        dashboardStore.updateActivityGraph(mappedData);
      },
      error: () => {
        setLoader(false);
        setRequestStatus(false);
        ToastService.showError("Error Occured");
      },
    });
  }

  const activitiyGraphWidgetData = filterActivityGraphWidgetData();
  if (showLoader) return <>{new Loader(true).loaderComponent}</>;

  function header(
    title: string,
    value: string,
    date: string,
    colorHex: string,
    percentage?: number,
    horizontalBox?: boolean
  ) {
    return (
      <FlexContainer>
        <div>
          <FlexContainer alignItems="center" spacing={8}>
            <RespresentativeBox bgColor={colorHex} horizontal={horizontalBox} />
            <CustomLabel> {title}</CustomLabel>
          </FlexContainer>
        </div>{" "}
        <CustomLabel> {value}</CustomLabel>
        <div>
          <FlexContainer alignItems="center" spacing={10}>
            <CustomLabel>{date}</CustomLabel>
            {(percentage || percentage === 0) && (
              <SensexBox
                up={percentage > 0}
                down={!percentage || percentage <= 0}
                fontSize="0.8rem"
              >
                {percentage < 0 ? (
                  <i className="fa fa-solid fa-sort-down"></i>
                ) : (
                  ""
                )}
                {percentage > 0 ? (
                  <i className="fa fa-solid fa-sort-up"></i>
                ) : (
                  ""
                )}
                {percentage < 0 ? -percentage : percentage}%
              </SensexBox>
            )}
          </FlexContainer>
        </div>
      </FlexContainer>
    );
  }

  // function priorMenuOption(value: string | React.ReactNode) {
  //     return <CustomLabel className="dpdn-overlay">{value}</CustomLabel>;
  // }

  // function generate2DatesRange(date1: Date, date2: Date, showYear = false) {
  //     if (showYear) {
  //         return (
  //             <>
  //                 {UtilityMethods.formatDateInString(date1)} - {UtilityMethods.formatDateInString(date2)}
  //             </>
  //         );
  //     }
  //     return (
  //         <>
  //             {UtilityMethods.formatDateInMonthAndDay(date1)} - {UtilityMethods.formatDateInMonthAndDay(date2)}
  //         </>
  //     );
  // }

  // function getPriorMenuOptionHtml(showTickIcon: boolean, dateRangeNode: React.ReactNode, onClick?: () => void) {
  //     return (
  //         <FlexContainer alignItems="center" spacing={0} onClick={() => onClick && onClick()}>
  //             <div className="activity-graph-img">
  //                 {showTickIcon && <img src={TickIcon} className="activity-graph-img" />}
  //             </div>
  //             <FlexContainer className="prior-outer-wrapper">{dateRangeNode}</FlexContainer>
  //         </FlexContainer>
  //     );
  // }

  // function getPriorDropDownOptions() {
  //     if (!dashboardStore.activityGraphWidgetData) return null;

  //     const isPriorMonthly = priorPeriodValue === 'MONTH';
  //     const isPriorYearly = priorPeriodValue === 'YEAR';
  //     const isPriorPeriod = priorPeriodValue === '';
  //     switch (filter.toUpperCase()) {
  //         case 'ALL':
  //             return null;
  //         case '1W':
  //         case '4W':
  //         case '1Q':
  //         case '1Y':
  //             return (
  //                 <div>
  //                     {/* {getPriorMenuOptionHtml(
  //                         isPriorPeriod,
  //                         <>
  //                             {priorMenuOption('PRIOR PERIOD')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodStart,
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodEnd,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod(''),
  //                     )} */}
  //                     {getPriorMenuOptionHtml(
  //                         isPriorYearly,
  //                         <>
  //                             {priorMenuOption('PRIOR YEAR')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.priorYearStart,
  //                                     dashboardStore.activityGraphWidgetData.priorYearEnd,
  //                                     true,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => (isPriorYearly ? setPeriorPeriod('') : setPeriorPeriod('YEAR')),
  //                     )}
  //                 </div>
  //             );
  //         case 'TODAY':
  //             return (
  //                 <div>
  //                     {getPriorMenuOptionHtml(
  //                         isPriorPeriod,
  //                         <>
  //                             {priorMenuOption('PRIOR DAY')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodStart,
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodEnd,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod(''),
  //                     )}
  //                     {getPriorMenuOptionHtml(
  //                         isPriorMonthly,
  //                         <>
  //                             {priorMenuOption('PRIOR MONTH')}
  //                             {priorMenuOption(
  //                                 UtilityMethods.formatDateInMonthAndDay(
  //                                     dashboardStore.activityGraphWidgetData.priorMonthStart,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => {
  //                             setPeriorPeriod('MONTH');
  //                         },
  //                     )}
  //                     {getPriorMenuOptionHtml(
  //                         isPriorYearly,
  //                         <>
  //                             {priorMenuOption('PRIOR YEAR')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.priorYearStart,
  //                                     dashboardStore.activityGraphWidgetData.priorYearEnd,
  //                                     true,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod('YEAR'),
  //                     )}
  //                 </div>
  //             );
  //         case 'WTD':
  //             return (
  //                 <div>
  //                     {getPriorMenuOptionHtml(
  //                         isPriorPeriod,
  //                         <>
  //                             {priorMenuOption('PRIOR WEEK')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodStart,
  //                                     dashboardStore.activityGraphWidgetData.previousPeriodEnd,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod(''),
  //                     )}
  //                     {getPriorMenuOptionHtml(
  //                         isPriorMonthly,
  //                         <>
  //                             {priorMenuOption('PRIOR MONTH')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.priorMonthStart,
  //                                     dashboardStore.activityGraphWidgetData.priorMonthEnd,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod('MONTH'),
  //                     )}
  //                     {getPriorMenuOptionHtml(
  //                         isPriorYearly,
  //                         <>
  //                             {priorMenuOption('PRIOR YEAR')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.priorYearStart,
  //                                     dashboardStore.activityGraphWidgetData.priorYearEnd,
  //                                     true,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod('YEAR'),
  //                     )}
  //                 </div>
  //             );
  //         case 'MTD':
  //         case 'QTD':
  //             const caption = filter === 'MTD' ? 'MONTH' : 'QUARTER';
  //             const isSelected = priorPeriodValue === caption;
  //             return (
  //                 <>
  //                     <div>
  //                         {getPriorMenuOptionHtml(
  //                             isSelected,
  //                             <>
  //                                 {priorMenuOption('PRIOR ' + caption)}
  //                                 {priorMenuOption(
  //                                     generate2DatesRange(
  //                                         dashboardStore.activityGraphWidgetData.previousPeriodStart,
  //                                         dashboardStore.activityGraphWidgetData.previousPeriodEnd,
  //                                     ),
  //                                 )}
  //                             </>,
  //                             () => setPeriorPeriod('MONTH'),
  //                         )}
  //                         {getPriorMenuOptionHtml(
  //                             isPriorYearly,
  //                             <>
  //                                 {priorMenuOption('PRIOR YEAR')}
  //                                 {priorMenuOption(
  //                                     generate2DatesRange(
  //                                         dashboardStore.activityGraphWidgetData.priorYearStart,
  //                                         dashboardStore.activityGraphWidgetData.priorYearEnd,
  //                                     ),
  //                                 )}
  //                             </>,
  //                             () => setPeriorPeriod('YEAR'),
  //                         )}
  //                     </div>
  //                 </>
  //             );
  //         case 'YTD':
  //             return (
  //                 <div>
  //                     {getPriorMenuOptionHtml(
  //                         isPriorYearly,
  //                         <>
  //                             {priorMenuOption('PRIOR YEAR')}
  //                             {priorMenuOption(
  //                                 generate2DatesRange(
  //                                     dashboardStore.activityGraphWidgetData.priorYearStart,
  //                                     dashboardStore.activityGraphWidgetData.priorYearEnd,
  //                                 ),
  //                             )}
  //                         </>,
  //                         () => setPeriorPeriod('YEAR'),
  //                     )}
  //                 </div>
  //             );

  //         default:
  //             return null;
  //     }
  // }

  // function dropdownHeader(title: string, value: string, date: string, colorHex: string, percentage?: number) {
  //     const menuOptions = getPriorDropDownOptions();
  //     return (
  //         <FlexContainer>
  //             <div>
  //                 <FlexContainer alignItems="center" spacing={8}>
  //                     <RespresentativeBox bgColor={colorHex} />
  //                     {!openPriorPeriod && (
  //                         <>
  //                             <CustomLabel className="clickable"> {title}</CustomLabel>
  //                             {menuOptions && <i className="fa fa-solid fa-sort-down prior-option-dpdn" />}
  //                         </>
  //                     )}

  //                     {openPriorPeriod && (
  //                         <OverlayDropdownMenu className="activity-graph-dpdn">
  //                             <CustomLabel className="clickable"> {title}</CustomLabel>
  //                             {menuOptions && <i className="fa fa-solid fa-sort-down prior-option-dpdn" />}

  //                             <div className="dropdown-menu">
  //                                 <div className="dropdown-item-wrapper">
  //                                     <Dropdown.Item className={`dropdown-item ${priorPeriodValue ? 'active' : ''}`}>
  //                                         <div>
  //                                             <FlexContainer
  //                                                 alignItems="center"
  //                                                 fxLayout="column"
  //                                                 onClick={() => setPriorPeriodOpen(!openPriorPeriod)}
  //                                                 className="activity-options-wrapper"
  //                                             >
  //                                                 {menuOptions}
  //                                             </FlexContainer>
  //                                         </div>
  //                                     </Dropdown.Item>
  //                                 </div>
  //                             </div>
  //                         </OverlayDropdownMenu>
  //                     )}
  //                 </FlexContainer>
  //             </div>{' '}
  //             <CustomLabel> {value}</CustomLabel>
  //             <div>
  //                 <FlexContainer alignItems="center" spacing={10}>
  //                     <CustomLabel>{date}</CustomLabel>
  //                     {(percentage || percentage === 0) && (
  //                         <SensexBox up={percentage > 0}>
  //                             {percentage < 0 ? <i className="fa fa-solid fa-sort-down"></i> : ''}
  //                             {percentage > 0 ? <i className="fa fa-solid fa-sort-up"></i> : ''}
  //                             {percentage < 0 ? (--percentage).toFixed(2) : percentage.toFixed(2)}%
  //                         </SensexBox>
  //                     )}
  //                 </FlexContainer>
  //             </div>
  //         </FlexContainer>
  //     );
  // }

  function calculatePercentage(current: number, previous: number) {
    if (current === 0 && previous === 0) return 0;
    if (previous === 0) return 100;

    const change = current - previous;
    const percentage = (change / previous) * 100;
    return UtilityMethods.formatDecimalNumber(percentage);
  }

  function dateHeader(date1: Date, date2: Date) {
    //  if (!showProjection()) return '';

    if (date1.getFullYear() === date2.getFullYear()) {
      return (
        UtilityMethods.formatDateInMonthAndDay(date1) +
        " - " +
        UtilityMethods.formatDateInMonthAndDay(date2)
      );
    } else {
      return (
        UtilityMethods.formatDateInString(date1) +
        " - " +
        UtilityMethods.formatDateInString(date2)
      );
    }
  }

  function showProjection() {
    const showPeriodSection =
      filter == "TODAY" ||
      filter === "WTD" ||
      filter === "MTD" ||
      filter === "QTD" ||
      filter === "YTD";
    return showPeriodSection;
  }

  function showPrior() {
    return filter.toUpperCase() !== "ALL";
  }

  function CustomTooltip({ active, payload }: any) {
    if (!active || !payload || !payload.length) return null;

    const data = payload[0].payload;
    const dollarSymbol =
      type === "GrossRevenue" || type === "NetRevenue" ? "$" : "";

    if (
      data.currentPeriodValue === 0 &&
      data.priorPeriodValue === 0 &&
      data.projectedValue === 0
    )
      return null;
    return (
      <AcitivityGraphToolTip
        bgColor={getColorForTooltip(
          data.isCurrentPeriod,
          data.isPriorPeriod,
          data.isProjected
        )}
      >
        <FlexContainer fxLayout="column">
          <div>
            {data.isPriorPeriod ? data.priorToolTipLabel : data.toolTipLabel}
          </div>
          {data.currentPeriodValue > 0 && (
            <div>
              Current:{" "}
              {`${dollarSymbol}${AccountSettingsStore.formatAmount(data.currentPeriodValue, true)}`}
            </div>
          )}
          {showProjection() && data.projectedValue > 0 && (
            <div>
              Projected:{" "}
              {`${dollarSymbol}${AccountSettingsStore.formatAmount(data.projectedValue, true)}`}
            </div>
          )}
          {data.priorPeriodValue > 0 && (
            <div>
              Prior:{" "}
              {`${dollarSymbol}${AccountSettingsStore.formatAmount(data.priorPeriodValue, true)}`}
            </div>
          )}
        </FlexContainer>
      </AcitivityGraphToolTip>
    );
  }

  function formatYAxis(tickItem: number): string {
    if (tickItem < 1000) return tickItem.toString();
    return `${tickItem / 1000}k`;
  }

  function getColor(
    isCurrentPeriod: boolean,
    isPriorPeriod: boolean,
    isProjected: boolean
  ) {
    return isCurrentPeriod
      ? "#C9D5FC"
      : isPriorPeriod
        ? "#7B94E5"
        : isProjected
          ? "#EDEDED"
          : "#C9C9C9";
  }
  function getColorForTooltip(
    isCurrentPeriod: boolean,
    isPriorPeriod: boolean,
    isProjected: boolean
  ) {
    return isCurrentPeriod
      ? "#7B94E5"
      : isPriorPeriod
        ? "#7B94E5"
        : isProjected
          ? "#777777"
          : "#C9C9C9";
  }

  function getHighLightedColor(
    isCurrentPeriod: boolean,
    isPriorPeriod: boolean,
    isProjected: boolean
  ) {
    return isCurrentPeriod
      ? "#556BB8"
      : isPriorPeriod
        ? "#556BB8"
        : isProjected
          ? "#AAAAAA"
          : "#C9C9C9";
  }

  function filterActivityGraphWidgetData() {
    const activityGraphData = dashboardStore.activityGraphWidgetData;
    if (!activityGraphData || !activityGraphData)
      return dashboardStore.activityGraphWidgetData;

    return activityGraphData;

    // if (getPriorDropDownOptions() && priorPeriodValue) {
    //     const graphData = activityGraphData.graphData.filter((x) => x.date <= activityGraphData.previousPeriodEnd);

    //     return new ActivityGraphWidgetDataModel({ ...activityGraphData, graphData: graphData });
    // } else {
    //     return dashboardStore.activityGraphWidgetData;
    // }
  }

  // function getPriorPeriodCaption() {
  //     if (!priorPeriodValue) return 'PRIOR PERIOD';

  //     return 'PRIOR ' + priorPeriodValue;
  // }

  // function isTodayFilter() {
  //     return filter === 'TODAY';
  // }

  // function priorHeaderDates() {
  //     if (!activitiyGraphWidgetData) return '';

  //     switch (priorPeriodValue) {
  //         case 'YEAR':
  //             if (isTodayFilter()) {
  //                 return UtilityMethods.formatDateInMonthAndDay(activitiyGraphWidgetData.priorDay);
  //             }
  //             return dateHeader(activitiyGraphWidgetData.priorYearStart, activitiyGraphWidgetData.priorYearEnd);
  //         case 'MONTH':
  //             if (isTodayFilter()) {
  //                 return UtilityMethods.formatDateInMonthAndDay(activitiyGraphWidgetData.priorDay);
  //             }
  //             return dateHeader(activitiyGraphWidgetData.priorMonthStart, activitiyGraphWidgetData.priorMonthEnd);
  //         default:
  //             return dateHeader(
  //                 activitiyGraphWidgetData.previousPeriodStart,
  //                 activitiyGraphWidgetData.previousPeriodEnd,
  //             );
  //     }
  // }

  const dollarSymbol =
    type === "GrossRevenue" || type === "NetRevenue" ? "$" : "";

  const value1 =
    dollarSymbol +
    AccountSettingsStore.formatAmount(
      activitiyGraphWidgetData.currentPeriodValue,
      true
    );
  const value2 =
    dollarSymbol +
    AccountSettingsStore.formatAmount(
      activitiyGraphWidgetData.previousPeriodValue,
      true
    );
  const value3 =
    dollarSymbol +
    AccountSettingsStore.formatAmount(
      activitiyGraphWidgetData.projectedValue,
      true
    );
  // const value4 =
  //     dollarSymbol + UtilityMethods.numberWithCommas(activitiyGraphWidgetData.previousProjectedValue);

  const currentPercentage = calculatePercentage(
    activitiyGraphWidgetData.currentPeriodValue,
    activitiyGraphWidgetData.previousPeriodValue
  );
  const projectedPercentage = calculatePercentage(
    activitiyGraphWidgetData.projectedValue,
    activitiyGraphWidgetData.previousProjectedValue
  );

  // function isTodayFilter() {
  //     return filter === 'TODAY';
  // }

  const graphData = activitiyGraphWidgetData.graphData.map((x) => {
    return x;
    // if (
    //     (x.isCurrentPeriod || x.isProjected) &&
    //     !x.isPriorPeriod &&
    //     activitiyGraphWidgetData.currentPeriodStart < x.date
    // ) {
    //     delete (x as any).priorPeriodValue;
    // }

    // return x as any;
  });
  return (
    <>
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
        padding="0px 0px 50px"
      >
        <div>
          <FlexContainer alignItems="center" spacing={10}>
            <img src={GrossRevenueIcon} />
            <div className="activity-card-header gross-revenue-dropdown">
              {" "}
              <SingleSelect
                selectedKey={type}
                searchable={false}
                nameKeys={["label"]}
                valueKeys={["value"]}
                options={[
                  [
                    { label: "Gross Revenue", value: "GrossRevenue" },
                    { label: "Net Revenue", value: "NetRevenue" },
                    { label: "Orders", value: "Orders" },
                    { label: "Payments", value: "Payments" },
                  ],
                ]}
                onChange={(option) => {
                  !isRequestInProgress && setType(option.value);
                }}
              />
            </div>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer justifyContent="center" spacing={20}>
            {filterOptions.map((option) => {
              const isActive = filter === option;
              return (
                <FilterTimePeriod
                  active={isActive}
                  key={option}
                  onClick={() => {
                    if (!isRequestInProgress) {
                      setPeriorPeriod("");
                      setFilterType(option);
                    }
                  }}
                >
                  {option}
                </FilterTimePeriod>
              );
            })}
          </FlexContainer>
        </div>
      </FlexContainer>

      <div className="activity-graph-body">
        <FlexContainer className="revenue-sub-headers">
          <div>
            {header(
              "CURRENT PERIOD",
              value1,
              dateHeader(
                activitiyGraphWidgetData.currentPeriodStart,
                activitiyGraphWidgetData.currentPeriodEnd
              ),
              "#C9D5FC",
              currentPercentage
            )}
          </div>

          <div>
            {showProjection() &&
              header(
                "PROJECTED",
                value3,
                dateHeader(
                  activitiyGraphWidgetData.projectedPeriodStart,
                  activitiyGraphWidgetData.projectedPeriodEnd
                ),
                "#EDEDED",
                projectedPercentage
              )}
          </div>
          <div>
            {showPrior() &&
              header(
                "PRIOR",
                value2,
                dateHeader(
                  activitiyGraphWidgetData.previousPeriodStart,
                  activitiyGraphWidgetData.previousPeriodEnd
                ),
                "#7B94E5",
                projectedPercentage,
                true
              )}
          </div>
          {/* <div ref={ref} onClick={() => togglePriorPeriod()}>
                      {dropdownHeader(getPriorPeriodCaption(), value2, priorHeaderDates(), '#556BB8')}
                  </div> */}
          {/* <div>
                      {showProjection() &&
                          header(
                              'PRIOR ACTUAL',
                              value4,
                              dateHeader(
                                  activitiyGraphWidgetData.priorActualPeriodStart,
                                  activitiyGraphWidgetData.priorActualPeriodEnd,
                              ),
                              '#777777',
                          )}
                  </div> */}
        </FlexContainer>
        <ResponsiveContainer width="100%" height="50%">
          <ComposedChart
            width={500}
            height={300}
            data={graphData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis
              dataKey={"label"}
              tickLine={false}
              axisLine={false}
              interval={"preserveStartEnd"}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              interval={1}
              tickFormatter={(value) => {
                return formatYAxis(value);
              }}
            />
            <Tooltip
              cursor={{ fill: "transparent" }}
              content={<CustomTooltip active={true} />}
            />

            {!priorPeriodValue && (
              <Bar
                onMouseEnter={(data, index) =>
                  handleMouseEnter(index, true, false, false)
                }
                onMouseLeave={() => handleMouseLeave()}
                activeBar={false}
                barSize={30}
                dataKey={"currentPeriodValue"}
                stackId="a"
                fill={getColor(true, false, false)}
              >
                {graphData.map(
                  (entry: ActivityGraphDataModel, index: number) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={
                        index === activeBar?.index && activeBar?.isCurrentPeriod
                          ? getHighLightedColor(true, false, false)
                          : getColor(true, false, false)
                      }
                      cursor="pointer"
                    />
                  )
                )}
              </Bar>
            )}

            {showProjection() && (
              <Bar
                barSize={30}
                dataKey="projectedValue"
                stackId="a"
                // fill={getColor(false, false, true)}
                onMouseEnter={(data, index) =>
                  handleMouseEnter(index, false, false, true)
                }
                onMouseLeave={() => handleMouseLeave()}
              >
                {graphData.map(
                  (entry: ActivityGraphDataModel, index: number) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={
                        index === activeBar?.index && activeBar?.isProjected
                          ? getHighLightedColor(false, false, true)
                          : getColor(false, false, true)
                      }
                    />
                  )
                )}
              </Bar>
            )}
            <Line
              type="linear"
              dataKey="priorPeriodValue"
              dot={false}
              strokeWidth={3}
              stroke={getColor(false, true, false)}
            />
            {/* {showProjection() && (
                          <Bar
                              barSize={30}
                              dataKey="priorActualValue"
                              stackId="a"
                              fill={getColor(false, false, false)}
                          />
                      )} */}
            {/* <Bar barSize={30} dataKey="priorPeriodValue" stackId="a" fill={getColor(false, true, false)} /> */}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default withRouter(observer(ActivityGraphWidget));
